import * as React from 'react';
import { Box, Badge, Group, ThemeIcon, createStyles, getStylesRef } from '@mantine/core';
import { NavLink } from 'react-router-dom';

// Local Components
import { NavLinkItemWrapper } from '../NavLinkItemWrapper';

// Types
import { NavLinkBase } from '../../types';
import { consolidateSteps } from '../../../Form/helpers/sectionHelpers';

const useStyles = createStyles((theme) => {
    return {
        unstyledLink: {
            color: theme.colors.dark[4]
        },
        linkActive: {
            '&, &:hover, button, button:hover': {
                // backgroundColor: '#f1f3f5',
                backgroundColor: theme.colors.brand[0],
                color: theme.fn.variant({ variant: 'light', color: theme.primaryColor }).color,
                [`& .${getStylesRef('icon')}`]: {
                    color: theme.fn.variant({ variant: 'light', color: theme.primaryColor }).color
                }
            }
        },
        badgeRoot: {
            borderRadius: '50%',
            padding: '0',
            width: '1.3rem',
            height: '1.3rem'
        }
    };
});

interface NavLinkItemProps extends NavLinkBase {
    className?: string;
    wrapped?: boolean;
    notificationCount?: number;
}

export const NavLinkItem: React.FC<NavLinkItemProps> = ({
    icon: Icon,
    label,
    link,
    className,
    wrapped,
    notificationCount,
    end = false
}) => {
    const { cx, classes } = useStyles();

    return (
        <NavLink
            to={link}
            end={end}
            className={({ isActive }) =>
                cx(classes.unstyledLink, {
                    [className ?? '']: true,
                    [classes.linkActive]: isActive
                })
            }
        >
            <NavLinkItemWrapper isWrapped={wrapped}>
                <Group position="apart" style={{ flex: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {Icon ? (
                            <ThemeIcon variant="subtle" size={30}>
                                <Icon size="1rem" />
                            </ThemeIcon>
                        ) : null}
                        <Box ml="md">{label}</Box>
                    </Box>
                    {notificationCount ? (
                        <Badge
                            variant="filled"
                            classNames={{
                                root: classes.badgeRoot
                            }}
                        >
                            {notificationCount}
                        </Badge>
                    ) : null}
                </Group>
            </NavLinkItemWrapper>
        </NavLink>
    );
};
